/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadsSetEnabledRequest
 */
export interface UploadsSetEnabledRequest {
    /**
     * 
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UploadsSetEnabledRequest interface.
 */
export function instanceOfUploadsSetEnabledRequest(value: object): value is UploadsSetEnabledRequest {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UploadsSetEnabledRequestFromJSON(json: any): UploadsSetEnabledRequest {
    return UploadsSetEnabledRequestFromJSONTyped(json, false);
}

export function UploadsSetEnabledRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadsSetEnabledRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function UploadsSetEnabledRequestToJSON(json: any): UploadsSetEnabledRequest {
    return UploadsSetEnabledRequestToJSONTyped(json, false);
}

export function UploadsSetEnabledRequestToJSONTyped(value?: UploadsSetEnabledRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

